import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  getTagsWatchlists,
  createTagsWatchlist,
  updateTagsWatchlist,
  deleteTagsWatchlist,
  TagsWatchlist,
  TagsWatchlistCreate,
  TagsWatchlistUpdate,
} from "./index";
import useAuth from "@/hooks/useAuth";

export const useTagsWatchlistsCRUD = () => {
  const queryClient = useQueryClient();
  const { authenticated } = useAuth();

  // Fetch tags watchlists
  const watchlistsQuery = useQuery({
    queryKey: ["tagsWatchlists"],
    queryFn: () => getTagsWatchlists(),
    select: (res) => res?.data || [],
    enabled: authenticated,
  });

  // Create tags watchlist
  const createMutation = useMutation({
    mutationFn: (data: TagsWatchlistCreate) => createTagsWatchlist(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["tagsWatchlists"] });
    },
  });

  // Update tags watchlist
  const updateMutation = useMutation({
    mutationFn: ({ id, data }: { id: number; data: TagsWatchlistUpdate }) =>
      updateTagsWatchlist(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["tagsWatchlists"] });
    },
  });

  // Delete tags watchlist
  const deleteMutation = useMutation({
    mutationFn: (id: number) => deleteTagsWatchlist(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["tagsWatchlists"] });
    },
  });

  return {
    watchlistsQuery,
    createMutation,
    updateMutation,
    deleteMutation,
  };
};

export type { TagsWatchlist, TagsWatchlistCreate, TagsWatchlistUpdate };
